import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import SectionHeading from '@/app/components/SectionHeading';

import MeasureCards from './MeasureCards';

const MeasureSection = () => {
  return (
    <LayoutGrid className="pt-20 lg:py-20" data-cy="measure-section">
      <GridItem colEnd={{ sm: 'full', lg: 'main' }} colStart={{ sm: 'main' }}>
        <SectionHeading
          animated
          content="science_research_2025_measure_title"
          typographyProps={{
            align: 'left',
            className: 'leading-tight tracking-tighter mb-10',
            color: 'inherit',
            Element: 'h3',
            variant: 'h2',
          }}
          wrapperAnimationProps={{
            initial: { filter: 'blur(5px)', opacity: 0 },
            transition: { delay: 0.2, duration: 0.75, type: 'tween' },
          }}
        />
        <MeasureCards />
      </GridItem>
    </LayoutGrid>
  );
};

export default MeasureSection;
